import { useMemo } from 'react';
import { all_routes } from '../Router/all_routes';
import { useShopId } from './useShopId';

export const useShopRoutes = () => {
  const { shopId } = useShopId();

  const shopRoutes = useMemo(() => {
    const routes = {};

    Object.entries(all_routes).forEach(([key, route]) => {
      if (route.includes(':shopId')) {
        routes[key] = route.replace(':shopId', shopId || 'all');
      } else {
        routes[key] = route;
      }
    });

    return routes;
  }, [shopId]);

  return shopRoutes;
};

export default useShopRoutes;